import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import { useDispatch } from 'react-redux';

import popup1 from '../../_assets/images/pop-up1.jpeg';
import popup2 from '../../_assets/images/pop-up2.jpeg';
import { useAppSelector } from '../../store';
import { increment, tuttorialClose } from '../../store/features/moments/momentsSlice';

const Tuttorial = () => {
    const dispatch = useDispatch();
    const { tuttorialIndex, eventList } = useAppSelector(state => state.moments);

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-02"
            open
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}>
            <Fade in>
                <div className="">
                    <a className="close-icon" onClick={() => dispatch(tuttorialClose())} href="#!">
                        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
                                stroke="#6C6C7D"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M21.875 13.125L13.125 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M13.125 13.125L21.875 21.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                    {tuttorialIndex === 0 && (
                        <a href="#!" onClick={() => dispatch(increment(1))}>
                            <img src={popup1}></img>
                        </a>
                    )}
                    {tuttorialIndex === 1 && (
                        <a href="#!" onClick={() => dispatch(increment(eventList?.items?.length === 0 ? 2 : 1))}>
                            <img src={popup2}></img>
                        </a>
                    )}
                </div>
            </Fade>
        </Modal>
    );
};

export default Tuttorial;
